export default "__VITE_ASSET__BDnuhkX7__"